import { FormGroup } from '../../../../ui/gzForm/formGroup/form-group';
import { SensorType } from '../../types/sensor-type';
import { O365SensorView } from '../../base/o365/view/O365SensorView';
import { O365SensorController } from '../../base/o365/controller/O365SensorController';
import { WEB_COMPONENT_SENSOR_O365_MAIL } from '../../../../webcomponents.constants';
import { O365AuditWebController } from '../controller/O365AuditWebController';
import { O365AuditFields } from '../../constants';

export class O365AuditWebView extends O365SensorView {
  public formGroup: FormGroup;

  static getRequirements(dependencies: any): string {
    return `
        <div class="sensor-requirement" sensor-type="${SensorType.O365_AUDIT}">
          <gz-title class="sensor-title">${dependencies.translateFn('For the Audit sensor setup:')}</gz-title>
          <ol>
            <li>${dependencies.translateFn('Your managed application is {registration} in Microsoft Azure AD.', {
              registration:
                '<gz-link type="underline" href="https://docs.microsoft.com/en-us/azure/active-directory/reports-monitoring/howto-configure-prerequisites-for-reporting-api#register-an-application"><span>' +
                dependencies.translateFn('registered') +
                '</span></gz-link>',
            })}</li>
            <li>${dependencies.translateFn('The following Office 365 {boldApplicationPermissions} are configured:', {
              boldApplicationPermissions: '<b>' + dependencies.translateFn('Application permissions') + '</b>',
            })}
              <ul style="list-style-type: disc;">
                <li>ActivityFeed.Read</li>
                <li>ActivityFeed.ReadDlp</li>
                <li>ServiceHealth.Read</li>
                <li>Sites.Read.All</li>
              </ul>
            </li>
            <li>${dependencies.translateFn(
              'The following Microsoft Graph {boldApplicationPermissions} are configured if you want response capabilities directly from GravityZone: User.ReadWrite.All, IdentityRiskyUser.ReadWrite.All.',
              {
                boldApplicationPermissions: '<b>' + dependencies.translateFn('Application permissions') + '</b>',
              }
            )}
            </li>
            <li>${dependencies.translateFn(
              'User Administrator role is assigned to your O365 application. It is required only for response actions directly from GravityZone.'
            )}</li>
            <li>${dependencies.translateFn('Admin consent is granted.')}</li>
            <li>${dependencies.translateFn('{clientSecret} is generated unless you have one already.', {
              clientSecret:
                '<gz-link type="underline" href="https://docs.microsoft.com/en-us/azure/active-directory/reports-monitoring/howto-configure-prerequisites-for-reporting-api#get-your-applications-client-secret"><span>' +
                dependencies.translateFn('Client secret ') +
                '</span></gz-link>',
            })}</li>

            <li>${dependencies.translateFn('Microsoft Compliance {auditLink} must be enabled.', {
              auditLink:
                '<gz-link type="underline" href="https://docs.microsoft.com/en-us/microsoft-365/compliance/turn-audit-log-search-on-or-off?view=o365-worldwide#turn-on-audit-log-search"><span> ' +
                dependencies.translateFn('Auditing') +
                '</span></gz-link>',
            })}</li>
            <li>${dependencies.translateFn('The following subscriptions should be enabled:')}
             <ul style="list-style-type: disc;">
                <li>Audit.AzureActiveDirectory</li>
                <li>Audit.Exchange</li>
                <li>Audit.General</li>
                <li>Audit.SharePoint</li>
                <li>DLP.All</li>
              </ul>
            </li>
          </ol>
          <p>${dependencies.translateFn('Note')}</p>
          <p>${dependencies.translateFn('For a complete Office 365 sensor integration guide, refer to {detailLink}.', {
            detailLink:
              '<gz-link type="underline" href="https://www.bitdefender.com/business/support/en/77211-452343-the-o365-sensor.html"><span>' +
              dependencies.translateFn('this KB article') +
              '</span></gz-link>',
          })}</p>
        </div>
        `;
  }

  getDomElements(): void {
    super.getDomElements();
    this.dom = {
      $applicationId: this.shadow.querySelector('#' + O365AuditFields.APPLICATION),
      $tenantId: this.shadow.querySelector('#' + O365AuditFields.TENANT),
      $clientSecret: this.shadow.querySelector('#' + O365AuditFields.CLIENT_SECRET),
      ...this.baseDom,
    };
    this.getTranslations();
  }

  setTranslatedStrings() {
    super.setTranslatedStrings();
    this.setBaseTranslatedStrings(SensorType.O365_AUDIT);
  }

  public setEnableOnDataFields(isEnabled: boolean): void {
    super.setEnableOnDataFields(isEnabled);

    // disable reuse option if mail sensor is disabled
    if (!O365SensorController.isSensorEnabled(WEB_COMPONENT_SENSOR_O365_MAIL)) {
      this.dom.$reuseDataWrapper.Input.checked = false;
      this.dom.$reuseDataWrapper.disabled = true;
    }
  }
}
